// extracted by mini-css-extract-plugin
export default {"cardContent":"ModifierCodes_cardContent__hXmKn","checkboxesContainer":"ModifierCodes_checkboxesContainer__g-pQs","checkbox":"ModifierCodes_checkbox__2jlzV"};